import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { filter, map } from "rxjs";
import { ActorCardCollectionService } from "../actor-card-collection.service";
import { ActorCardItemService } from "./actor-card-item.service";


@Component({
  selector: 'ss-actor-card-item',
  templateUrl: './actor-card-item.component.html',
  styleUrls: ['./actor-card-item.component.scss'],

  providers: [
    ActorCardItemService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActorCardItemComponent implements OnInit {


  readonly hangingSignaturePositionSubject = this._actorCardItemService.hangingSignaturePositionSubject;
  @Input() get activity() {
    return this._actorCardItemService.activitySubject.value
  }
  set activity(value) {
    this._actorCardItemService.activitySubject.next(value)
  }

  readonly showSettingsSubject = this._actorCardItemService.showSettingsSubject;
  readonly selectedDocumentObs = this._actorCardItemService.selectedDocumentObs;
  readonly selectedDocumentSubject = this._actorCardItemService.selectedDocumentSubject;
  readonly inDragSubject = this._actorCardItemService.inDragSubject

  readonly scrollOffsetSubject = this._actorCardItemService.scrollOffsetSubject
  readonly dragStyleObs = this._actorCardItemService.dragStyleObs
  readonly isSmallerScreenObs = this._actorCardItemService.isSmallerScreenObs
  readonly backgroundColorObs = this._actorCardItemService.backgroundColorObs;
  readonly hideGroupSubject = this._actorCardCollectionService.hideGroupSubject;

  readonly #getHsla = (hue: number, opacity: number) => `hsla(${hue},50%,50%,${opacity})`;


  readonly borderObs = this._actorCardItemService.backgroundColorObs.pipe(
    map(backgroundColor => '2px solid ' + backgroundColor)
  )


  readonly backgroundObs = this._actorCardItemService.activitySubject.pipe(
    filter(Boolean),
    map((activity) => activity.actor.hue),
    map((hue) => this.#getHsla(hue, 0.05)),
  )

  constructor(
    private readonly _actorCardItemService: ActorCardItemService,
    private readonly _actorCardCollectionService: ActorCardCollectionService

  ) { }

  ngOnInit(): void {

  }


  dropSignature() {
    this._actorCardItemService.dropSignature();
  }


  nextSignature() {

    this._actorCardItemService.nextSignature()
  }

  prevSignature() {
    this._actorCardItemService.prevSignature()


  }

  toggleShowSettings() {
    this._actorCardItemService.toggleShowSettings()
  }
}
